<template>
  <div class="account-number-confirmation">
    <ValidationProvider
      class="account-number-confirmation__agreement"
      name="accountNumberConfirmation1"
      tag="div"
      v-slot="{ errors }"
    >
      <div>
        <label
          class="checkbox-inline required required--no-asterisk"
          :class="errors.length > 0 ? 'invalid' : ''"
        >
          <input
            name="accountNumberConfirmation1"
            type="checkbox"
            v-model="isVatExceptionChecked"
          />
          Oświadczam, że podany wyżej rachunek bankowy, z którego zostanie
          dokonana płatność na rzecz Pluxee Polska Sp. z o.o. w związku z
          realizacją zamówienia, spełnia łącznie następujące warunki:
          <ul>
            <li>należy do składającego niniejsze zamówienie,</li>
            <li>
              jest wykorzystywany przez składającego zamówienie do prowadzenia
              przez niego działalności gospodarczej,
            </li>
            <li class="asterisk">
              jest prowadzony w banku mającym siedzibę na terytorium RP.
            </li>
          </ul>
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error, idx) in errors">
          {{ error }}
        </li>
      </ul>
    </ValidationProvider>
    <ValidationProvider
      :rules="isVatExceptionChecked && { required: { allowFalse: false } }"
      class="account-number-confirmation__agreement"
      name="accountNumberConfirmation2"
      tag="div"
      v-slot="{ errors }"
    >
      <div>
        <label
          class="checkbox-inline required"
          :class="errors.length > 0 ? 'invalid' : ''"
        >
          <input
            name="accountNumberConfirmation2"
            type="checkbox"
            v-model="accountNumberConfirmation2"
          />
          Oświadczam, że przekazane informacje dotyczące podanego przeze mnie
          rachunku bankowego są prawdziwe, poprawne oraz zgodne z moją najlepszą
          wiedzą i przekonaniem.
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error, idx) in errors">
          {{ error }}
        </li>
      </ul>
    </ValidationProvider>
    <ValidationProvider
      :rules="isVatExceptionChecked && { required: { allowFalse: false } }"
      class="account-number-confirmation__agreement"
      name="accountNumberConfirmation3"
      tag="div"
      v-slot="{ errors }"
    >
      <div>
        <label
          class="checkbox-inline required"
          :class="errors.length > 0 ? 'invalid' : ''"
        >
          <input
            name="accountNumberConfirmation3"
            type="checkbox"
            v-model="accountNumberConfirmation3"
          />
          Jestem świadomy/a, że bez uzyskania przez składającego niniejsze
          zamówienie wyraźnej pisemnej zgody Pluxee Polska Sp. z o.o., należność
          za składane zamówienie nie może być regulowana przez podmiot trzeci, a
          płatność nie może pochodzić z zagranicznego rachunku bankowego. W
          przypadku dokonania płatności niezgodnie z powyższym oświadczeniem,
          zamówienie nie zostanie zrealizowane, a środki zostaną zwrócone na rachunek
          nadawcy, z potrąceniem kosztów poniesionych przez Pluxee Polska Sp. z
          o.o. z tytułu przelewu zwrotnego.
        </label>
      </div>
      <ul class="errors">
        <li :key="idx" class="text-danger" v-for="(error, idx) in errors">
          {{ error }}
        </li>
      </ul>
    </ValidationProvider>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  name: 'BankNumberConfirmation',
  data() {
    return {
      accountNumberConfirmation2: false,
      accountNumberConfirmation3: false,
    };
  },
  computed: {
    ...mapFields('bankNumber', ['isVatExceptionChecked']),
  },
};
</script>
